import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { PlusIcon, MinusIcon } from 'lucide-react';
const faqs = [{
  q: '¿Qué hace exactamente ESBELTA®?',
  a: 'ESBELTA® es una gomita funcional con Fórmula Ancestral diseñada para mujeres maduras. Combina 8 activos naturales que trabajan en conjunto para reducir el cortisol elevado, mejorar la sensibilidad a la insulina, apoyar el equilibrio hormonal y acelerar el metabolismo. No es una pastilla para adelgazar. Es una herramienta de equilibrio metabólico y hormonal.'
}, {
  q: '¿Cómo se toman?',
  a: '2 gomitas por día, de preferencia por la mañana con agua. Se pueden tomar con o sin comida.'
}, {
  q: '¿Cuándo empiezo a ver resultados?',
  a: 'La mayoría de las mujeres reporta cambios en la hinchazón y la energía durante la primera y segunda semana. Los cambios visibles en composición corporal suelen notarse a partir de las 3-4 semanas. Para resultados profundos y duraderos, recomendamos el pack de 3 meses en adelante.'
}, {
  q: '¿Tiene cafeína o algo que acelere el corazón?',
  a: 'No. La fórmula de ESBELTA® no contiene cafeína ni estimulantes cardíacos. La energía que genera es metabólica y hormonal, no química ni artificial. No genera ansiedad ni nerviosismo.'
}, {
  q: '¿Necesito hacer dieta o ejercicio?',
  a: 'No es obligatorio. ESBELTA® funciona incluso sin cambios drásticos en tu rutina. Dicho eso: si combinás las gomitas con pequeñas mejoras en tu alimentación o actividad física, los resultados se potencian significativamente.'
}, {
  q: '¿Sirve para la perimenopausia y menopausia?',
  a: 'Sí. De hecho, fue formulada especialmente para este contexto. La Ashwagandha, el Inositol y la Vitamina D3 son especialmente efectivos para los síntomas asociados al desequilibrio hormonal de la perimenopausia y menopausia: hinchazón, cansancio, cambios de humor, antojos y grasa abdominal.'
}, {
  q: '¿Tiene efectos secundarios?',
  a: 'ESBELTA® está formulada con ingredientes naturales y es bien tolerada. Algunas personas pueden experimentar leve digestión activa los primeros días. No se reportaron efectos adversos significativos.'
}, {
  q: '¿Puedo combinarla con otros suplementos o medicamentos?',
  a: 'Si tomás medicación regular, consultá con tu médico antes. No se recomienda combinar con otros suplementos que contengan los mismos activos para evitar duplicar dosis.'
}, {
  q: 'Contraindicaciones',
  a: 'No recomendado durante embarazo o lactancia. No apto para menores de 18 años. Si tenés alguna condición médica crónica, consultá con tu médico.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="bg-white py-16 md:py-24 px-4" data-id="element-52">
      <div className="max-w-3xl mx-auto" data-id="element-53">
        <h2 className="font-serif text-3xl md:text-4xl font-bold text-center text-gray-900 mb-12" data-id="element-54">
          ¿Alguna pregunta?
        </h2>

        <div className="space-y-4" data-id="element-55">
          {faqs.map((faq, idx) => <div key={idx} className="border border-gray-200 rounded-xl overflow-hidden" data-id="element-56">
              <button className="w-full flex items-center justify-between p-5 text-left bg-white hover:bg-gray-50 transition-colors" onClick={() => setOpenIndex(openIndex === idx ? null : idx)} data-id="element-57">
                <span className="font-bold text-gray-900 pr-4" data-id="element-58">{faq.q}</span>
                <span className="text-esbelta-violet flex-shrink-0" data-id="element-59">
                  {openIndex === idx ? <MinusIcon className="w-5 h-5" data-id="element-60" /> : <PlusIcon className="w-5 h-5" data-id="element-61" />}
                </span>
              </button>
              <AnimatePresence data-id="element-62">
                {openIndex === idx && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} className="overflow-hidden bg-gray-50" data-id="element-63">
                    <div className="p-5 pt-0 text-gray-600 leading-relaxed" data-id="element-64">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}